import type { ComponentType } from "react";
import { Briefcase, Direct, Judge, LikeDislike, Math as MathIcon, NotificationStatus, People } from "iconsax-react";
import { TengeCircleIcon } from "@/shared/assets/icons";
import accountingImg from "@/shared/assets/img/notifications/accounting.png";
import applicationsImg from "@/shared/assets/img/notifications/applications.png";
import approvalImg from "@/shared/assets/img/notifications/approval.png";
import financeImg from "@/shared/assets/img/notifications/finance.png";
import hrImg from "@/shared/assets/img/notifications/hr.png";
import legalImg from "@/shared/assets/img/notifications/legal.png";
import projectsImg from "@/shared/assets/img/notifications/projects.png";
import systemImg from "@/shared/assets/img/notifications/system.png";
import type { NotificationCategory } from "../types";

type CategoryChipIcon = ComponentType<{ size?: number | string; color?: string; className?: string }>;

interface CategoryConfig {
  labelKey: string;
  tileClass: string;
  image: string;
  imageClass: string;
  chipIcon: CategoryChipIcon;
}

export const CATEGORY_ORDER: NotificationCategory[] = [
  "system",
  "applications",
  "approval",
  "projects",
  "accounting",
  "finance",
  "hr",
  "legal",
];

export const CATEGORY_CONFIG: Record<NotificationCategory, CategoryConfig> = {
  system: {
    labelKey: "categories.system",
    tileClass: "bg-brand-200",
    image: systemImg,
    imageClass: "w-6 aspect-square",
    chipIcon: Direct,
  },
  hr: {
    labelKey: "categories.hr",
    tileClass: "bg-cyan-200",
    image: hrImg,
    imageClass: "w-8 aspect-square",
    chipIcon: People,
  },
  legal: {
    labelKey: "categories.legal",
    tileClass: "bg-orange-200",
    image: legalImg,
    imageClass: "w-8 aspect-square",
    chipIcon: Judge,
  },
  finance: {
    labelKey: "categories.finance",
    tileClass: "bg-lime-200",
    image: financeImg,
    imageClass: "w-8 aspect-square",
    chipIcon: TengeCircleIcon,
  },
  accounting: {
    labelKey: "categories.accounting",
    tileClass: "bg-pink-200",
    image: accountingImg,
    imageClass: "w-8 aspect-square",
    chipIcon: MathIcon,
  },
  projects: {
    labelKey: "categories.projects",
    tileClass: "bg-indigo-200",
    image: projectsImg,
    imageClass: "w-8 aspect-square",
    chipIcon: Briefcase,
  },
  applications: {
    labelKey: "categories.applications",
    tileClass: "bg-yellow-200",
    image: applicationsImg,
    imageClass: "w-8 aspect-square",
    chipIcon: NotificationStatus,
  },
  approval: {
    labelKey: "categories.approval",
    tileClass: "bg-brand-200",
    image: approvalImg,
    imageClass: "w-8 aspect-square",
    chipIcon: LikeDislike,
  },
};
